import { NEW_SCHOOL_FIELD } from "../../../constants/SchoolConstants";

export default function setNewSchoolFieldAction(data: any, field: string) {
    return {
        type: NEW_SCHOOL_FIELD,
        data,
        field
    };
}
